<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import ReadMoreIndowStories from '$lib/PageSections/ReadMoreIndowStories/ReadMoreIndowStories.svelte';

	import customerStoriesWindows from './images/customer-stories-house.jpg';
	import customerStoriesWindows2 from './images/customer-stories-house2.jpg';
	import customerStoriesWindows3 from './images/customer-stories-house3.jpg';
	import customerStoriesWindows4 from './images/customer-stories-house4.jpg';
	import windowInsertInstallation from './images/window-insert-installation.jpg';
</script>

<Section>
	<h2>Mid Century Modern, Meet Indow Windows</h2>
	<p>
		Cord and his partner Alfonso bought a piece of history when they purchased
		Case Study House #26. But soon after moving in they knew they faced a
		challenge blocking the cold air from all their beautiful windows.
	</p>
	<p>
		The only Case Study house in Northern California, Case Study House #26, was
		designed by architect Beverley David Thorne and built in 1963 in San Rafael
		California. It has four bedrooms, two bathrooms and is under 2,000 square
		feet. With windows throughout – Cord calls it a glass house – its very
		drafty windows and doors, which let in too much heat in the summer and cold
		in the winter, were an issue. Cord and Alfonso needed to solve their chilly
		air problem without damaging their historic home.
	</p>
	<Image src={customerStoriesWindows} class="no-bleed" loading="eager" />
	<p>
		The Case Study Homes were commissioned by Arts & Architecture Magazine
		starting in 1945. The idea: how should American families live post World War
		II? What does well-designed living for the masses, built out of modern
		materials, look like?
	</p>
	<p>
		Cord is a German-born architect who works at Google and studied history and
		the art of restoration in Berlin. It&apos;s not that he and his partner had
		to have a mid-century modern house. Number #26 appealed to them, because
		it&apos;s straightforward good design, one of a kind and very simple
		&quot;it was very clear and clean and this appealed to us&quot; said Cord.
	</p>
	<Image src={customerStoriesWindows2} class="no-bleed" />
</Section>

<Section backgroundColor="grey-light">
	<h2>Testimonials</h2>
	<Image src={windowInsertInstallation} class="no-bleed" />
	<p class="text-indow-blue! italic">
		&quot;I am amazed at how well they fit in and how easy they were to install,
		there was a noticeable difference right away and they didn&apos;t damage a
		thing.&quot;
	</p>
	<p>
		– Cord Struckmann, Owner of Case Study House #26, San Rafael California.
	</p>
	<a href="/resources/case-studies">Read more case studies.</a>
</Section>

<Section>
	<p>
		One contractor who looked at the windows wasn&apos;t comfortable replacing
		them and it would have been a fortune anyway to get the right insulating
		glass that was also extremely clear since today&apos;s modern glass has a
		slight green tint.
	</p>
	<p>
		So for the drafty clerestory windows in the main living area, they bought
		<a href="/products/uv-blocking-window-inserts">Museum Grade</a> clear window inserts
		which immediately blocked the drafts and cold radiating from the original windows.
	</p>
	<Image src={customerStoriesWindows3} class="no-bleed" />
	<p>
		The Museum Grade inserts also protects their art collection from fading in
		the intense sunlight that characterizes what Cord refers to as a glass
		house. And he appreciates that he can&apos;t see the inserts. They just
		blend in.
	</p>
	<p>
		Cord studied restoration in Germany but never thought he would be in a
		position to restore and preserve a house of his own. He loves that his
		decision to buy Indow inserts will leave no trace on the windows of this
		historic American dwelling.
	</p>
	<p>&quot;I didn&apos;t damage anything.&quot;</p>
	<Image src={customerStoriesWindows4} class="no-bleed" />
	<hr />
</Section>

<ReadMoreIndowStories />

<GetAFreeEstimate />
